import _ from "lodash";
import { HttpService } from "@/core";
import { ExportReq, ExportResp } from "@/core/interface";
import { VisaPageReq, VisaPageResp, VisaDetailResp, VisaReq } from "./visa.interface";

export class VisaService {
  static usePageApi() {
    const api = (params: VisaPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/first_party_visa/pageList",
        params,
      });
    return HttpService.usePagination<VisaPageResp>(api);
  }

  static usePageApiForWorkSetUpImport() {
    const api = (data: VisaPageReq) =>
      HttpService.axios({
        method: "POST",
        url: "/first_party_visa/pageListForWorkSetUpImport",
        data,
      });
    return HttpService.usePagination<VisaPageResp>(api);
  }

  static mergeMaterialsApi() {
    const api = (visaIds: string[]) =>
      HttpService.axios({
        method: "POST",
        url: "/first_party_visa/material/merge",
        data: { visaIds },
      });
    return HttpService.useRequest<any>(api);
  }

  static mergeQuantitiesApi() {
    const api = (visaIds: string[]) =>
      HttpService.axios({
        method: "POST",
        url: "/first_party_visa/quantities/merge",
        data: { visaIds },
      });
    return HttpService.useRequest<any>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/first_party_visa/${id}`,
      });
    return HttpService.useRequest<VisaDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: VisaReq) =>
      HttpService.axios({
        method: "POST",
        url: "/first_party_visa/all",
        data: VisaService.profileReqToAjaxData(data),
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  // 新的
  static useEditApiNew() {
    const api = (id: string, data: VisaReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/first_party_visa/${id}/updateAll`,
        data: VisaService.profileReqToAjaxData(data),
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  // 老的
  static useEditApi() {
    const api = (id: string, data: VisaReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/first_party_visa/${id}`,
        data: VisaService.profileReqToAjaxData(data),
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/first_party_visa/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static useExportApi() {
    const api = (ids: ExportReq) =>
      HttpService.axios({
        method: "GET",
        url: "/first_party_visa/export",
        params: { ids },
      });
    return HttpService.useRequest<ExportResp>(api);
  }

  static profileReqToAjaxData(req: VisaReq) {
    req = _.cloneDeep(req);
    return req;
  }

  static detailRespToVisaReq(resp: VisaDetailResp): VisaReq {
    const profileReq = new VisaReq();
    profileReq.pick(resp);
    return profileReq;
  }
}
